/**
 * API根地址文件
 * @type {string}
 */
const api = 'http://api.master.china-pcs.com/';
export default api;




// WEBPACK FOOTER //
// ./src/assets/javascript/api.js